import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, createContext } from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { getFirestore, doc, getDocs, onSnapshot, collection } from 'firebase/firestore';
import appFirebase from '../../Firebase/Firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMoneyBill, faWallet, faCalendarAlt, faComments, faSignOutAlt, faSitemap, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import logoClaro from '../../img/logoDark.png';
import { Menu, X } from 'lucide-react';
import './NavBarV3.css';
import logo from '../../images/Logo.png'; // Asegúrate de importar la imagen
import { useTipoEspacio } from '../context/FiltroTipoEspacioContext';
import coworkingB from '../../img/coworkingB.png';
import serviciosB from '../../img/servicioB.png';
import academiaB from '../../img/academiaB.png';
import coworkingN from '../../img/coworkingN.png';
import serviciosN from '../../img/servicioN.png';
import academiaN from '../../img/academiaN.png';
const avatarsMap = {
    userAvatar1: require('../../images/1.png'),
    userAvatar2: require('../../images/2.png'),
    userAvatar3: require('../../images/3.png'),
    userAvatar4: require('../../images/4.png'),
    userAvatar5: require('../../images/5.png'),
    userAvatar6: require('../../images/6.png'),
    userAvatar7: require('../../images/7.png'),
    userAvatar8: require('../../images/8.png'),
};

const db = getFirestore(appFirebase);
const auth = getAuth();
function NavBarV3({ isDarkMode, toggleDarkMode }) {
    const { setTipoSeleccionado } = useTipoEspacio(); // Usamos el contexto para actualizar el estado
    
    const handleTipoEspacioSelect = (idTipoEspacio) => {
        setTipoSeleccionado(idTipoEspacio); // Actualiza el tipo seleccionado globalmente
    };
  
    
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(isDarkMode));
        if (isDarkMode) {
            document.body.classList.add('dark-mode');
        } else {
            document.body.classList.remove('dark-mode');
        }
    }, [isDarkMode]);
    const [avatarName, setAvatarName] = useState('userAvatar1');
    const [usuario, setUsuario] = useState(null);
    const [userName, setUserName] = useState('');
    const [role, setRole] = useState('');
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const userMenuRef = useRef(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const getAvatarSrc = (avatarName) => avatarsMap[avatarName] || avatarsMap.userAvatar1;
    const [menuOpen, setMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [tipoEspacios, setTipoEspacios] = useState([]);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true); // Se hace scroll más de 50px
            } else {
                setScrolled(false); // No se hace scroll
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    useEffect(() => {
        const fetchTipoEspacios = async () => {
            const querySnapshot = await getDocs(collection(db, "tipoespacio"));
            const espacios = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTipoEspacios(espacios);
        };

        fetchTipoEspacios();
    }, []);
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUsuario(user);
                const userDocRef = doc(db, 'usuarios', user.uid);
                const unsubscribeSnapshot = onSnapshot(userDocRef, (doc) => {
                    if (doc.exists()) {
                        const data = doc.data();
                        setRole(data.role);
                        setUserName(data.name || '');
                        setAvatarName(data.avatar || 'userAvatar1');
                    } else {
                        console.log('No such document!');
                    }
                });
                return () => unsubscribeSnapshot();
            } else {
                setUsuario(null);
                setRole('');
                setUserName('');
                setAvatarName('userAvatar1');
            }
        });
        return () => unsubscribe();
    }, [auth, db]);
    const toggleUserMenu = () => setUserMenuOpen(!userMenuOpen);

    const [errors, setErrors] = useState({});
    const handleMenuLinkClick = () => {
        setMenuOpen(false);
    };
    const handleButtonClick = () => {
        handleMenuLinkClick();
        setIsModalOpen(true);  // Abre el modal al hacer clic en el botón
    };
    const handleSignOut = () => {
        signOut(auth);
        setUserMenuOpen(false);
    };
    const handleProfileClick = () => {
        setUserMenuOpen(false);
        navigate('/myprofile');
    };
    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${menuOpen ? 'menu-open' : ''}`}>
            <div className="navbar__container">
                <div className="navbar__desktop">
                    <div className="navbar__left">
                        <Link to="/">
                            <img src={isDarkMode ? logoClaro : logo} alt="logo" className="logo-img" />
                        </Link>
                    </div>
                    <ul className={`navbar__menu_c ${menuOpen ? 'open' : ''}`}>
                        <li><Link to="/coworking"><img src={isDarkMode ? coworkingN : coworkingB} className="iconos-navbar6" />Coworking</Link></li>
                        <li><Link to="/servicios"><img src={isDarkMode ? serviciosN : serviciosB} className="iconos-navbar6" />Servicios </Link></li>
                        <li><Link to="https://edu-laofi-academy.odoo.com/home-academy" target="_blank"><img src={isDarkMode ? academiaN : academiaB} className="iconos-navbar6" />Academia </Link></li>
                    </ul>
                    <div className="navbar__right">
                        <label className="switch">
                            <input type="checkbox" onChange={toggleDarkMode} checked={isDarkMode} />
                            <span className="slider"><span className="thumb-icon">{isDarkMode ? '🌙' : '🌞'}</span></span>
                        </label>
                        
                        <div className="cuenta-icon">
                            {!usuario ? (
                                <Link to="/login">Inicia sesión</Link>
                            ) : (
                                <div className="navbar__account-button" onClick={toggleUserMenu} ref={userMenuRef}>
                                    <img src={getAvatarSrc(avatarName)} alt="Avatar" className="navbar__avatar" /> Mi Cuenta
                                    {userMenuOpen && (
                                        <ul className="navbar__submenu_2">
                                            <span className="navbar__username">{userName}</span><br />
                                            <small className="user-email">{usuario.email}</small>
                                            <li onClick={handleProfileClick}><FontAwesomeIcon icon={faUser} /> Perfil</li>
                                            {role === 'admin' && (
                                                <ul>
                                                    <li>
                                                        <Link to="/create-coin-package" onClick={handleMenuLinkClick} className='navbar__color_letra' >
                                                            <FontAwesomeIcon icon={faMoneyBill} /> Crear Paquete de Monedas
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/verficarCoinsComprados" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                            <FontAwesomeIcon icon={faSitemap} /> Verificar Compras
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                            <FontAwesomeIcon icon={faCalendarAlt} /> Reservas
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/space" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                            <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link to="/users" onClick={handleMenuLinkClick} className='navbar__color_letra' >
                                                            <FontAwesomeIcon icon={faUserGroup} /> Usuarios
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/Busquedas" onClick={handleMenuLinkClick} className='navbar__color_letra' >
                                                            <FontAwesomeIcon icon={faCalendarAlt} /> Busquedas
                                                        </Link>
                                                    </li>
                                                </ul>
                                            )}
                                            {role === 'user' && (
                                                <>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} className='navbar__color_letra' >
                                                            <FontAwesomeIcon icon={faWallet} /> Monedero
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/reservasRealizadas" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                            <FontAwesomeIcon icon={faCalendarAlt} /> Mis Reservas
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/coin-purchase" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                            <FontAwesomeIcon icon={faComments} /> Comentarios
                                                        </Link>
                                                    </li>
                                                </>
                                            )}
                                            {
                                                role === 'prov' && (
                                                    <>
                                                        <li>
                                                            <Link to="/coin-purchase" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                                <FontAwesomeIcon icon={faWallet} /> Monedero
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/Reservas_Admin" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                                <FontAwesomeIcon icon={faCalendarAlt} /> Reservas
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/space" onClick={handleMenuLinkClick} className='navbar__color_letra' >
                                                                <FontAwesomeIcon icon={faSitemap} /> Pon tu espacio
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/proveedor/misMarcas" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                                <FontAwesomeIcon icon={faSitemap} /> Administra tu marca
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/coin-purchase" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                                <FontAwesomeIcon icon={faComments} /> Comentarios
                                                            </Link>
                                                        </li>
                                                        <li>
                                                            <Link to="/users" onClick={handleMenuLinkClick} className='navbar__color_letra'>
                                                                <FontAwesomeIcon icon={faUserGroup} /> Clientes
                                                            </Link>
                                                        </li>
                                                    </>
                                                )
                                            }
                                            <li onClick={handleSignOut}><FontAwesomeIcon icon={faSignOutAlt} /> Cerrar sesión</li>
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                
            </div>

            <div className="tipoespacios-menu desktop-tipos-espacios">
                {tipoEspacios.map((espacio) => (
                    <div
                        key={espacio.IdTipoEspacio} // cuidado: es IdTipoEspacio, no espacio.id
                        className="tipoespacio-item"
                        onClick={() => handleTipoEspacioSelect(espacio.IdTipoEspacio)} // Actualiza el estado global
                    >
                        {/* Imagen del icono */}
                        <img
                            src={espacio.icono}
                            alt={espacio.TipoEspacio}
                            className={`tipoespacio-icono${scrolled ? ' scrolled' : ''}`}
                        />
                        {/* Texto del tipo de espacio */}
                        <span>{espacio.TipoEspacio}</span>
                    </div>
                ))}
            </div>  
           
        </nav>
    );
}

export default NavBarV3;
